<template>
    <div>
        <h4>Payment Information</h4>
        <div class="col-12 mt-2 mb-2">
            
            
            <div class="border rounded bg-white p-3 mb-2">
                <h5 class="mb-2">Payment Summary</h5>
                <ul class="list-group mb-2 d-block" id="fee-list">
                    <template v-if="UseMemberFee">
                        <li  class="d-flex list-group-item">
                            <div class="form-check form-switch">
                                <input class="form-check-input ms-0" type="checkbox" disabled v-model="event_fee_accept" />
                            </div>
                            <span>Event Fee</span>
                            <span><del>{{ `$ ${event.EventFee.toFixed(2)}` }}</del></span>
                        </li>
                        <li  class="d-flex list-group-item">
                            <div class="form-check form-switch">
                                <input class="form-check-input" style="margin-left: 0;" type="checkbox" disabled v-model="event_fee_accept" />
                            </div>
                            <span>Event Fee <span class="text-success">(Member District)</span></span>
                            <span>{{ `$ ${event.EventFeeMember.toFixed(2)}` }}</span>
                        </li>
                    </template>

                    <li v-else-if="event.EventFee >= 0" class="d-flex list-group-item">
                        <div class="form-check form-switch">
                            <input class="form-check-input" style="margin-left: 0;" type="checkbox" disabled v-model="event_fee_accept" />
                        </div>
                        <span>Event Fee</span>
                        <span>{{ `$ ${event.EventFee.toFixed(2)}` }}</span>
                    </li>

                    <li v-if="event.GradFee > 0" class="d-flex list-group-item">
                        <div class="form-check form-switch">
                            <input name="pay_gradfee" class="form-check-input" style="margin-left: 0;" type="checkbox" id="input-pay-gradfee" @change="updateFee" ref="gradfee_switch" v-model="grad_fee_accept" />
                        </div>
                        <span>Grad Fee</span>
                        <span>{{ `$ ${event.GradFee.toFixed(2)}` }}</span>
                    </li>

                    <li v-if="event.EventFee < 0" class="d-flex list-group-item bg-secondary">
                        <div class="d-flex flex-grow-1">
                            <div class="align-self-center me-3 badge bg-primary rounded-pill"><h5 class="fas fa-info text-white mx-2"></h5></div>
                            <div class="">Special payment instructions. See event details for more information.</div>
                        </div>
                    </li>

                    <li v-if="event.EventFee > 0 || event.GradFee > 0" class="d-flex list-group-item bg-secondary" >
                        <div></div>
                        <span>Total</span>
                        <span ref="fee_total">{{ `$ ${EventFeeTotal.toFixed(2)}` }}</span>
                    </li>
                </ul>
            </div>

            <div v-if="event.EventFee != 0 && event.GradFee != 0">
                <form-payment-type-selector 
                    v-if="AcceptCC || event.CheckPayment || event.POPayment || event._AgencyAgreement.HasCode"
                    v-model="payment_type"
                    ></form-payment-type-selector>
                <form-payment-type-details 
                    v-if="AcceptCC || event.CheckPayment || event.POPayment || event._AgencyAgreement.HasCode"
                    :paymentType="payment_type"
                    v-model="payment"
                    ref="pay_details"
                ></form-payment-type-details>
            </div>
        </div>
    </div>
</template>

<script>
import FormPaymentTypeSelector from './FormPaymentTypeSelector.vue';
import FormPaymentTypeDetails from './FormPaymentTypeDetails.vue';

export default {
    components: {
        FormPaymentTypeSelector,
        FormPaymentTypeDetails,
    },

    props: {
        event: {
            type: Object,
            required: true,
            default: function(data={}) {
                return {
                    EventFee: data.EventFee ?? 0.0,
                    EventFeeMember: data.EventFeeMemeber ?? 0.0,
                    GradFee: data.GradFee ?? 0.0,
                    CCPayment: !!parseInt(data.CCPayment) ?? false, // Cast to bool
                    CheckPayment: !!parseInt(data.CheckPayment) ?? false,
                    CheckPayInstructions: data.CheckPayInstructions ?? '',
                    POPayment: !!parseInt(data.POPayment) ?? false,
                    POPayInstructions: data.POPayInstructions ?? '',
                    _AgencyAgreement: {
                        Data: data._AgencyAgreement.Data ?? [],
                        HasCode: !!parseInt(data._AgencyAgreement.HasCode) ?? false
                    },
                };
            }
        },

        user: {
            // type: Object,
            required: true,
            default: function(data={}) {
                return {
                    member: data.member ?? false,
                };
            },
            validator: prop => typeof prop === 'object' || prop === null
        },

        value: {
            type: Object,
            required: true,
            default: function(data={}) {
                return {};
            }
        }
    },

    computed: {
        UseMemberFee: function() {
            if (this.user === null) {
                return false;
            }

            if (!this.user.hasOwnProperty('member')) {
                return false;
            }

            return (this.event.EventFee > 0) && (this.event.EventFeeMember && this.user.member);
        },

        EventFeeTotal: function() { 
            return this.UseMemberFee ? parseFloat(this.event.EventFeeMember) : parseFloat(this.event.EventFee); 
        },

        AcceptCC: function() {
            return this.event.CCPayment && this.event.EventFee > 0;
        },
    },

    methods: {
        updateFee() {
            const event_fee = this.UseMemberFee ? parseFloat(this.event.EventFeeMember) : parseFloat(this.event.EventFee);

            if (this.$refs.gradfee_switch.checked) {
                var fee_total = event_fee + parseFloat(this.event.GradFee);
            } else {
                var fee_total = event_fee;
            }
            
            this.$refs.fee_total.innerHTML = `$ ${fee_total.toFixed(2)}`;
        },

        async submit() {
            if (this.payment_type == 'cc') {
                await this.$refs.pay_details.$refs.cc_form.submitCard();
            }

            const data = {
                event_fee_accept: this.event_fee_accept,
                grad_fee_accept: this.grad_fee_accept,

                payment_type: this.payment_type,
                payment: this.payment,

            }

            this.$emit('input', data);
        },
    },

    data() {
        return {
            event_fee_accept: true,
            grad_fee_accept: false,

            payment_type: null,
            payment: {},
        };
    }
}
</script>

<style scoped>
    #fee-list input {
        margin-left: 0;
        padding-left: 0;
    }
    
    #fee-list li > div {
        width: 3.5em;
        padding: 0;
    }
    
    #fee-list li:last-of-type {
        font-weight: bold;
    }
    
    #fee-list li > span:first-of-type {
        flex-grow: 2;
    }
</style>